import React from 'react';
import { useTranslation } from 'react-i18next';
import { isUndefined } from 'lodash';
import dayjs from 'dayjs';
import { DATETIME_FORMAT_DATETIME } from '../../../../../utils/helpers/CommonHelper.jsx';

export function LastUpdatedAt({ lastUpdatedAtString }) {
  const { t } = useTranslation();

  return (
    <p className="meteo-station-last-updated-at">
      {t('Dátum aktualizácie')}:
      <strong>
        {!isUndefined(lastUpdatedAtString)
          ? dayjs(lastUpdatedAtString).format(DATETIME_FORMAT_DATETIME)
          : '-'}
      </strong>
    </p>
  );
}
